import DefaultLayout from "@/components/DefaultLayout"
import FeaturedSection from "@/components/FeaturedSection"
import Head from "next/head"
import { useState } from "react"

export default function Topsellernew() {
  interface SeoInfo {
    description: string;
    keywords: string;
    title: string;
  }

  const [seoDescription, setSeoDescription] = useState<SeoInfo>({
    description: "",
    keywords: "",
    title: ""
  })

  // 配置默认排序
  const defaultSort = {
    sortDirection: "DESC",
    sortBy: "clearanceType"
  }

  return (
    <>
      <Head>
        <title>{`Mega Clearance Sales | Save Up to 90% on Dog Beds Cat Trees Kids Tables Plant Stands Flash Sale Items`}</title>
        <meta name="keywords" content={`Clearance sales, outdoor furniture sale, furniture sale, clearance, lego clearance, clearance sales australia, christmas clearance, clearance items, bathroom clearance, appliance clearance, clearance toys, online toy sales, fitness machines for sale, treadmill clearance, dog beds clearance, children table and chairs clearance`}></meta>
        <meta name="description" content={`Shop our Mega Clearance Sales and enjoy up to 90% savings on dog beds, cat trees, plant stands, and more! These online clearance items are sold in limited quantities for limited-time sale. Hurry up!`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout notStickyNavbar={true}>
        <FeaturedSection type="clearance" setSeoDescription={setSeoDescription} defaultSort={defaultSort} />
      </DefaultLayout>
    </>
  )
}